import React from 'react';
import DefaultChatViewVisibilityDialog from './NavCollapse/DefaultChatViewVisibilityDialog';

type ViewsPagesVisibilityContextValue = {
  openDefaultViewVisibilityDialog: (viewId: string) => void;
};

const ViewsPagesVisibilityContext = React.createContext<ViewsPagesVisibilityContextValue | null>(null);

export function useViewsPagesVisibilityOptional(): ViewsPagesVisibilityContextValue | null {
  return React.useContext(ViewsPagesVisibilityContext);
}

type ViewsPagesVisibilityProviderProps = {
  children: React.ReactNode;
};

/**
 * עוטף את קבוצת «תצוגות» בסיידבר — מאפשר ל־NavItem לפתוח דיאלוג נראות (לחיצה כפולה, מנהלים)
 */
export function ViewsPagesVisibilityProvider({ children }: ViewsPagesVisibilityProviderProps) {
  const [dialogViewId, setDialogViewId] = React.useState<string | null>(null);

  const openDefaultViewVisibilityDialog = React.useCallback((viewId: string) => {
    setDialogViewId(viewId);
  }, []);

  const value = React.useMemo(
    () => ({
      openDefaultViewVisibilityDialog,
    }),
    [openDefaultViewVisibilityDialog],
  );

  return (
    <ViewsPagesVisibilityContext.Provider value={value}>
      {children}
      {dialogViewId ? (
        <DefaultChatViewVisibilityDialog viewId={dialogViewId} onClose={() => setDialogViewId(null)} />
      ) : null}
    </ViewsPagesVisibilityContext.Provider>
  );
}
